import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';

// Context
import { AuthContext } from '../utilities/auth-context';

// Components
import Login from './auth/login';
import Dashboard from './pages/dashboard';
import Settings from './pages/settings';

const AuthenticatedRoutes = ({ isAuthenticated, setIsAuthenticated }) => {
    
    const { state } = useContext(AuthContext);

    return (
        <Routes>
            {isAuthenticated === null ? (
                <Route path='*' element={<div>Loading...</div>} />
            ) : isAuthenticated === true ? (
                <>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/settings' element={<Settings />} />
                </>
            ) : (   
                <>
                    <Route path='*' element={<Login onAuthenticate={setIsAuthenticated} />} />
                    {/* <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/reset-password' element={<ResetPassword />} /> */}
                </>
            )}
        </Routes>
    );
};

export default AuthenticatedRoutes;
